import { Box, ListItem } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"

export function MovementRow({ item }) {
    return (
        <ListItem>
            <ListItemBox>
                <Box flex={1}>
                    {item.position}. {item.title}
                </Box>
                <Box width={125}>{item.previousPosition}</Box>
            </ListItemBox>
        </ListItem>
    )
}
